export const FORM_NAMES = {
  name: "name",
  url: "url",
};
